// src/components/Home.js

import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const calculators = [
  {
    id: 'minuli-topli',
    title: 'Puno radno vrijeme sa toplim obrokom',
    description: 'Obračun plate sa uvećanjima i odbicima na platu.',
  },
  { id: 'kalkulator-plata',
    title: 'Puno radno vrijeme BEZ toplog obroka',
    description: 'Obračun plate bez toplog obroka sa uvećanjima i odbicima na platu.',
  },
  {
    id: 'ugovor-o-djelu',
    title: 'Ugovor o djelu / Dopunski rad',
    description: 'Obračun prema ugovoru o djelu ili dopunskom radnom odnosu.',
  },
  {
    id: 'privremeni-povremeni',
    title: 'Privremeni i povremeni poslovi',
    description: 'Obračun za privremene i povremene angažmane.',
  },
  {
    id: 'datum-staza',
    title: 'Radni staž',
    description: 'Pronalazak tačnog datuma za punu godinu radnog staža.',
  },
  {
    id: 'zakup',
    title: 'Zakup imovine',
    description: 'Izračun zakupa pokretne ili nepokretne imovine.',
  },
  {
    id: 'menadzerski-ugovor',
    title: 'Menadžerski ugovor',
    description: 'Obračun bez formalnog radnog odnosa (menadžerski ugovor).',
  },
  {
    id: 'autorski-ugovor',
    title: 'Autorski ugovor',
    description: 'Izračun naknade po autorskom ugovoru.',
  },
  {
    id: 'ostali-dohodak',
    title: 'Ostali dohodak',
    description: 'Obračun ostalih vrsta dohotka.',
  },
  {
    id: 'doprinosi-nekom',
    title: 'Nekomercijalno gazdinstvo',
    description: 'Doprinosi za nekomercijalno gazdinstvo.',
  },
  {
    id: 'doprinosi-kom-pio',
    title: 'Komercijalno gazdinstvo (45/37)',
    description: 'Komercijalno gazdinstvo (osiguranici na PIO).',
  },
  {
    id: 'doprinosi-kom-nepio',
    title: 'Komercijalno gazdinstvo (55/55)',
    description: 'Komercijalno gazdinstvo (nisu osiguranici na PIO).',
  },
  {
    id: 'doprinosi-vlasnik',
    title: 'Vlasnik – osnovno zanimanje',
    description: 'Doprinosi za vlasnika preduzetničke radnje.',
  },
  {
    id: 'doprinosi-samostalno',
    title: 'Samostalno zanimanje',
    description: 'Doprinosi za samostalnu djelatnost.',
  },
];

export default function Home() {
  return (
    <div className="home-wrapper">
      <h1 className="home-title">Kalkulatori za Republiku Srpsku</h1>
      <div className="cards-grid">
        {calculators.map((calc) => (
          <Link
            key={calc.id}
            to={`/${calc.id}`}
            className="card-link"
          >
            <div className="card">
              <h2 className="card-heading">{calc.title}</h2>
              <p className="card-desc">{calc.description}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
